import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ArrowRight } from 'lucide-react';
import { catalogueApi } from '../../services/api';
import { CategoryTiles } from './CategoryTiles';
import { Spinner } from './CatalogueShell';

export const BrandLightingTab = ({ brandId, brandName }) => {
  const [overview, setOverview] = useState(null);
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    catalogueApi.overview(brandId).then((r) => setOverview(r.data));
  }, [brandId]);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/brand/${brandId}/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div data-testid="brand-lighting-tab">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <h2 className="text-2xl font-medium text-gray-900">{brandName} Lighting</h2>
          {overview && <p className="text-gray-500 text-sm mt-1">{overview.total} products · {overview.familyCount} families</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <form onSubmit={submit} className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search e.g. KLYFTA, pendant, brass"
              className="text-sm border border-gray-200 rounded-md pl-9 pr-3 py-2 w-full sm:w-72 focus:outline-none focus:ring-1 focus:ring-gray-400"
              data-testid="brand-lighting-search" />
          </form>
          <Link to={`/brand/${brandId}/lighting`} className="inline-flex items-center justify-center px-4 py-2 text-sm bg-gray-900 text-white rounded-sm hover:bg-gray-800 transition-colors" data-testid="brand-lighting-open">
            Open lighting overview <ArrowRight className="h-4 w-4 ml-2" />
          </Link>
        </div>
      </div>
      {overview ? <CategoryTiles brandId={brandId} overview={overview} /> : <Spinner />}
    </div>
  );
};
